// section-recommendations-grid.js - FIXED VERSION
class RecommendationsGrid extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.init());
    } else {
      setTimeout(() => this.init(), 100);
    }
  }

  init() {
    this.sectionId = this.dataset.sectionId;
    this.productId = this.dataset.productId;
    this.limit = this.dataset.limit || 4;
    this.renderContainer = this.querySelector('.js-recommendations-grid__render-container');
    
    // Only fetch if needed
    if (this.productId && this.productId !== '' && this.shouldFetchRecommendations()) {
      this.fetchRecommendations();
    }
  }

  shouldFetchRecommendations() {
    return !this.renderContainer || this.renderContainer.children.length === 0;
  }

  fetchRecommendations() {
    const url = `/recommendations/products?section_id=${this.sectionId}&product_id=${this.productId}&limit=${this.limit}`;
    
    setTimeout(() => {
      fetch(url)
        .then(response => {
          if (!response.ok) throw new Error('Network response was not ok');
          return response.text();
        })
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendationsContainer = html.querySelector('.js-recommendations-grid__render-container');
          
          if (recommendationsContainer && this.renderContainer) {
            // Store the HTML but don't insert it yet
            const newContent = recommendationsContainer.innerHTML;
            
            // Clear the container
            this.renderContainer.innerHTML = '';
            
            // Insert the new content
            this.renderContainer.innerHTML = newContent;
            
            // Dispatch a custom event to let other scripts know recommendations were loaded
            this.dispatchEvent(new CustomEvent('recommendationsLoaded', {
              bubbles: true,
              detail: {
                productId: this.productId,
                count: this.renderContainer.querySelectorAll('.new-product-card').length
              }
            }));
            
            // Reinitialize add-to-cart buttons
            if (window.attachAddToCartListeners) {
              setTimeout(() => {
                window.attachAddToCartListeners();
              }, 100);
            }
          }
        })
        .catch(e => {
          console.error('Could not fetch product recommendations:', e);
        });
    }, 300);
  }
}

// Register the custom element
if (!customElements.get('s-recommendations-grid')) {
  customElements.define('s-recommendations-grid', RecommendationsGrid);
}